import React from "react";

const About = () => {
  return (
    <div className="container my-5 p-4 bg-white rounded">
      <h5
        className="mb-3 fw-bold"
        style={{
          background: "linear-gradient(90deg, #A14BFF, #0F81FF)",
          WebkitBackgroundClip: "text",
          WebkitTextFillColor: "transparent",
        }}
      >
        Okey Doke
      </h5>
      <h1 className="mb-4 fw-bold">About Us</h1>

      <p>
        Welcome to Okey Doke! We’re passionate about delivering a smart and
        intuitive experience to our users. This page gives you insight into who
        we are, what we do, and what drives us forward.
      </p>
      <h2 className="h5 mt-4">Our Mission</h2>
      <p>
        Our mission is to build user-friendly mobile experiences that help
        people navigate the world with ease and confidence. We believe
        technology should simplify lives, not complicate them.
      </p>
      <h2 className="h5 mt-4">Our Vision</h2>
      <p>
        We envision a future where everyone can explore new places, access
        helpful information, and feel secure using digital tools that respect
        privacy and deliver value.
      </p>
      <h2 className="h5 mt-4">Our Team</h2>
      <p>
        Our team consists of passionate developers, designers, and thinkers who
        care deeply about solving real-world problems through technology. We
        work remotely and collaboratively to bring innovative solutions to life.
      </p>
      <h2 className="h5 mt-4">Technologies We Use</h2>
      <p>
        From modern frameworks like React Native and Redux to location-based
        services and AI-powered features, we use the best tools to provide a
        seamless experience for our users.
      </p>
      <h2 className="h5 mt-4">Get in Touch</h2>
      <p>
        We’d love to hear from you! Whether you have feedback, suggestions, or
        partnership inquiries, feel free to reach out.
        <br />
        <strong>Email:</strong>{" "}
        <a href="mailto:sirilexelot@gmail.com">sirilexelot@gmail.com</a>
      </p>
      <p className="text-muted small mt-4">
        This page was last updated on April 20, 2025
      </p>
    </div>
  );
};

export default About;
